import { useEffect, useState } from "react";
import { Form, Row, Col, Spinner, Button } from "reactstrap";
import { useFieldArray, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";

import MyInput from "../../MyComp/UI/form/MyInput";
import MySelect from "../../MyComp/UI/form/MySelect";
import MyMobile from "../../MyComp/UI/form/MyMobile";
import MyButton from "../../MyComp/UI/form/MyButton";
import { getHospitalDetails, hospitalApprovalAPI } from "../../api/doctor";
import { toast } from "react-toastify";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import { BASE_URL_IMG, icuNicuOptions } from "../../assets/constants";
import MyTextArea from "../../MyComp/UI/form/MyTextArea";
import useLogout from "../../hooks/useLogout";

const HospitalForm = ({}) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const { logout } = useLogout();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    trigger,
    setError,
    clearErrors,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      objectionKeys: [],
      approvedKeys: [],
      name: "",
      hospital_type: "",
      regsitration_number: "",
      hospital_mobile: "",
      contact_person: "",
      alternate_mobile: "",
      pin_code: "",
      district: "",
      state: "",
      hospital_address: "",
      hospital_full_address: "",
      storeTypeDD: [],
      // Additional Details
      in_house_pharmacy_service: "",
      ambulance_service: "",
      icu_service: "",
      cashLess_insurance_service: "",
      food_service: "",
      start_time: "",
      end_time: "",
      hospita_image: null,
      mode: location?.state?.mode || "Add",
      actionType: null,
      hospital: [
        {
          image: null,
          image_url: null,
        },
      ],
    },
  });

  const [mode, setMode] = useState(location?.state?.mode || "Add");
  const yesNoOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];
  const { fields, append, remove } = useFieldArray({
    control,
    name: "hospital",
  });

  // Fetch hospital details and prefill form
  const fetchHospitalDetails = async () => {
    setIsLoading(true);
    const payload = {
      hospitalId: location?.state?.hospitalId,
    };

    try {
      const res = await getHospitalDetails(payload);
      if (res.data.status === true) {
        const data = res.data.data;

        // Map main hospital fields
        setValue("name", data.name || "");
        setValue("hospital_type", data.hospitalType || "");
        setValue("regsitration_number", data.registrationNumber || "");
        setValue("hospital_mobile", data.mobile || "");
        setValue("contact_person", data.contactPerson || "");
        setValue("alternate_mobile", data.alternateContactNumber || "");
        setValue("pin_code", data.pincode || "");
        setValue("district", data.district || "");
        setValue("state", data.state || "");
        setValue("hospital_address", data.addressLine2 || "");
        setValue("hospital_full_address", data.addressLine2 || "");
        setValue("hospital_type", data.hospitalType || "");
        //   setValue("storeTypeDD", [data.hospitalType] || []);

        // Map services safely (services may be empty)
        const services = data.services || {};
        setValue("diagnostic_service", yesNoOptions?.find((item) => item?.value == services?.diagnostic_service) ?? "");
        setValue(
          "in_house_pharmacy_service",
          yesNoOptions?.find((item) => item?.value == services?.in_house_pharmacy_service) ?? "",
        );
        setValue(
          "ambulance_service",
          yesNoOptions?.find((item) => item?.value == services.ambulance_service),
        );
        setValue(
          "icu_service",
          icuNicuOptions?.find((item) => item.value == services?.icu_service),
        );
        setValue(
          "cashLess_insurance_service",
          yesNoOptions?.find((item) => item?.value == services.cashLess_insurance_service),
        );
        setValue(
          "food_service",
          yesNoOptions?.find((item) => item?.value == services.food_service),
        );
        setValue("start_time", services.start_time || "");
        setValue("end_time", services.end_time || "");
        console.log("data", data?.hospitalDocuments);
        if (data.hospitalDocuments && Array.isArray(data.hospitalDocuments)) {
          // Clear existing fields
          remove();
          data?.hospitalDocuments?.forEach((item) => {
            append({
              image: item?.url ? `${BASE_URL_IMG}${item.url}` : null,
              image_url: item?.url ? `${BASE_URL_IMG}${item.url}` : null,
            });
          });
        }
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    fetchHospitalDetails();
  }, []);

  const [imageOpen, setImageOpen] = useState(false);
  const handleImageOpenPreview = (row) => {
    const imageUrl = `${row?.image}`;
    setValue("image_preview", imageUrl);
    setImageOpen(true);
  };
  const onFormSubmit = (formData) => {
    if (mode == "Approval" && watch("actionType") == "approve") {
      const body = {
        remark: watch("remark") || "",
        keys: watch("objectionKeys")?.map((item) => item) || [],
        hospitalId: location?.state?.hospitalId || "",
        actionType: "approve",
      };
      hospitalApprovalAPI(body)
        .then((res) => {
          if (res.data.status === true) {
            navigate("/hospital-list");
            toast.success(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === false) {
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("loading", false);
          toast.error(err?.response?.data?.message);
        });
    }
  };

  return (
    <>
      <Head title="Doctor Registration" />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Hospital Approve"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    navigate("/hospital-list");
                  }}
                >
                  <Icon name={"arrow-left"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewAltCard>
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row>
                <Col xs="12" sm="6" md="4" lg="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Hospital Name"
                    name="name"
                    placeholder="Enter Hospital Name"
                    required
                    disabled={mode === "Approval"}
                  />
                </Col>

                <Col xs="12" sm="6" md="4" lg="3">
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Hospital Type"
                    name="hospital_type"
                    placeholder="Select Hospital Type"
                    required
                    options={watch("storeTypeDD")}
                    disabled={mode === "Approval"}
                  />
                </Col>

                {/* <Col xs="12" sm="6" md="4" lg="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Registration Number"
                    name="regsitration_number"
                    placeholder="Enter Registration Number"
                    required
                    disabled={mode === "Approval"}
                  />
                </Col> */}

                <Col xs="12" sm="6" md="4" lg="3">
                  <MyMobile
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Hospital Mobile Number"
                    name="hospital_mobile"
                    placeholder="Enter Mobile Number"
                    required
                    disabled={mode === "Approval"}
                  />
                </Col>

                <Col xs="12" sm="6" md="4" lg="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Contact Person"
                    name="contact_person"
                    placeholder="Enter Contact Person"
                    required
                    disabled={mode === "Approval"}
                  />
                </Col>

                <Col xs="12" sm="6" md="4" lg="3">
                  <MyMobile
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Alternate Mobile"
                    name="alternate_mobile"
                    placeholder="Enter Alternate Mobile"
                    disabled={mode === "Approval"}
                  />
                </Col>

                <Col xs="12" sm="6" md="4" lg="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Pin Code"
                    name="pin_code"
                    placeholder="Enter Pin Code"
                    required
                    min={6}
                    max={6}
                    disabled={mode === "Approval"}
                  />
                </Col>

                <Col xs="12" sm="6" md="4" lg="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="District"
                    name="district"
                    disabled
                    readonly
                  />
                </Col>

                <Col xs="12" sm="6" md="4" lg="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="State"
                    name="state"
                    disabled
                    readonly
                  />
                </Col>

                <Col md="12" className={``}>
                  <MyTextArea
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Hospital Address"}
                    name={"hospital_address"}
                    placeholder={"Enter hospital address"}
                    required
                    // min={25}
                    // max={500}
                    cols={2}
                    row={2}
                    disabled={mode === "Approval"}
                  />
                </Col>
              </Row>
              <Row className="mt-4">
                <h5 className="my-3">Additional Details</h5>

                <Col xs="12" sm="6" md="4" lg="2">
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Diagnostic Service"
                    name="diagnostic_service"
                    options={yesNoOptions}
                    disabled={mode === "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="2">
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="In-house Pharmacy Service"
                    name="in_house_pharmacy_service"
                    options={yesNoOptions}
                    disabled={mode === "Approval"}
                  />
                </Col>

                <Col xs="12" sm="6" md="4" lg="2">
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Ambulance Service"
                    name="ambulance_service"
                    options={yesNoOptions}
                    disabled={mode === "Approval"}
                  />
                </Col>

                <Col xs="12" sm="6" md="4" lg="2">
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="ICU / NICU"
                    name="icu_service"
                    options={[
                      { value: "ICU", label: "ICU" },
                      { value: "NICU", label: "NICU" },
                    ]}
                    disabled={mode === "Approval"}
                  />
                </Col>

                <Col xs="12" sm="6" md="4" lg="2">
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Cashless Insurance"
                    name="cashLess_insurance_service"
                    options={yesNoOptions}
                    disabled={mode === "Approval"}
                  />
                </Col>

                <Col xs="12" sm="6" md="4" lg="2">
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Food Service"
                    name="food_service"
                    options={yesNoOptions}
                    disabled={mode === "Approval"}
                  />
                </Col>

                <Col xs="12" sm="6" md="4" lg="2">
                  <label className="form-label fw-semibold">Start Time</label>
                  <input
                    type="time"
                    className="form-control"
                    {...register("start_time", { required: "Start time is required" })}
                    disabled={mode === "Approval"}
                  />
                  {errors.start_time && <small className="text-danger">{errors.start_time.message}</small>}
                </Col>

                <Col xs="12" sm="6" md="4" lg="2">
                  <label className="form-label fw-semibold">End Time</label>
                  <input
                    type="time"
                    className="form-control"
                    {...register("end_time", {
                      required: "End time is required",
                      validate: (endTime) => endTime > watch("start_time") || "End time must be after start time",
                    })}
                    disabled={mode === "Approval"}
                  />
                  {errors.end_time && <small className="text-danger">{errors.end_time.message}</small>}
                </Col>

                {fields.map((field, index) => (
                  <>
                    <Col md="2" key={field.id}>
                      {" "}
                      <ImageUpload
                        getValues={getValues}
                        id={`image_${index}`}
                        watch={watch}
                        trigger={trigger}
                        setError={setError}
                        clearErrors={clearErrors}
                        errors={errors}
                        register={register}
                        label={`Hospital ${index + 1}`}
                        image={`hospital.${index}.image`}
                        image_url={`hospital.${index}.image_url`}
                        setValue={setValue}
                        handleImageOpenPreview={handleImageOpenPreview}
                        // required
                        validateDoc
                        rm
                        index={index}
                        remove={remove}
                        approve={mode === "Approval" ? true : false}
                        size={2048}
                      />
                    </Col>
                  </>
                ))}
                {(watch("mode") === "Add" || watch("mode") === "Edit") && (
                  <Col md="2">
                    <Button
                      style={{ marginTop: "30px" }}
                      type="button"
                      color="primary"
                      className=" "
                      id="addDegree"
                      onClick={() => {
                        append({ image: null, image_url: null });
                      }}
                    >
                      {"Add Hospital Image"}
                    </Button>{" "}
                  </Col>
                )}
              </Row>

              {mode == "Approval" && (
                <Row>
                  {/* <Col md={2}>
                                  <div className="form-group my-2">
                                    <label className="form-label fw-semibold">Rating</label>
              
                                    <input
                                      type="number"
                                      min="1"
                                      max="5"
                                      step="0.1"
                                      placeholder="1.0 – 5.0"
                                      {...register("rating", {
                                        required: "Rating is required",
                                        min: { value: 1, message: "Minimum is 1" },
                                        max: { value: 5, message: "Maximum is 5" },
                                        valueAsNumber: true,
                                      })}
                                      className="form-control"
                                    />
              
                                    {errors?.rating && <small className="text-danger">{errors.rating.message}</small>}
                                  </div>
                                </Col> */}

                  <Col md="12" className={``}>
                    <MyTextArea
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Remark"}
                      name={"remark"}
                      placeholder={"Reason for approval/rejection"}
                      required
                      // min={25}
                      // max={500}
                      cols={2}
                      row={2}
                    />
                  </Col>
                </Row>
              )}
              {mode == "Approval" && (
                <>
                  <Row>
                    <div className="d-flex mt-5">
                      <div className="form-group" style={{ marginTop: "31px" }}>
                        <Button
                          color="primary"
                          size="md"
                          type="submit"
                          onClick={() => setValue("actionType", "approve")}
                          disabled={isLoading || watch("objectionKeys")?.length > 0} // Disable if already rejected
                        >
                          {isLoading ? <Spinner size="sm" color="light" /> : "Approve Hospital"}
                        </Button>
                      </div>

                      {/* <div className="form-group mx-2" style={{ marginTop: "31px" }}>
                        <Button
                          disabled={isLoading || watch("objectionKeys")?.length <= 0} // Disable if already rejected
                          color="primary"
                          size="md"
                          type="submit"
                          onClick={() => setValue("actionType", "changeRequest")}
                        >
                          {isLoading ? <Spinner size="sm" color="light" /> : "Change Request"}
                        </Button>
                      </div> */}
                    </div>
                  </Row>
                </>
              )}
            </Form>
          </PreviewAltCard>
        </Block>
      </Content>
    </>
  );
};

export default HospitalForm;
